import { GET_FACILITIES_SUCCESS } from "./facilities.types";

const initialState = {
  facilitiesList: null,
};

export const facilitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FACILITIES_SUCCESS:
      return {
        ...state,
        facilitiesList: action.payload,
      };

    default:
      return state;
  }
};
